/* Tienda Q4 · landings de producto. Sin dependencias; se carga con defer. Sin JS la página funciona igual:
   el formulario envía a /cart/add con return_to=/checkout y el texto de las reseñas sale entero. */
(() => {
  'use strict';
  document.documentElement.classList.add('q4-js');
  const raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const moneda = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  // 24/10 (GA4): la ficha publica a los píxeles de Shopify (Configuración → Eventos del cliente → «GA4 Noasse») el precio
  // QUE SE VE (lanzamiento/BF/normal y total del pack); los eventos estándar de Shopify llevan el precio normal de la variante.
  // Sin gtag en el tema: todo GA4 va por ese píxel (también el pago), con el consentimiento de Shopify y sin duplicados.
  const publicar = (nombre, datos, intento = 0) => {
    const a = window.Shopify && Shopify.analytics;
    if (a && typeof a.publish === 'function') { try { a.publish(nombre, datos); } catch (e) {} return; }
    if (intento < 20) setTimeout(() => publicar(nombre, datos, intento + 1), 250);
  };

  document.querySelectorAll('[data-q4-compra]').forEach((sec) => {
    const form = sec.querySelector('[data-q4-form]');
    if (!form) return;
    // Packs: radios de cantidad (p01, una variante) o radios de VARIANTE (p02, «packs_variantes»: 1 kit, 2 kits…).
    const radios = form.querySelectorAll('input[data-unidades]');
    const porVariante = !!form.querySelector('input[type="radio"][name="id"]');
    const total = form.querySelector('[data-q4-total]');
    const boton = form.querySelector('[data-q4-boton]');
    const barra = sec.querySelector('[data-q4-barra]');
    const barraTotal = barra && barra.querySelector('[data-q4-barra-total]');
    const barraPack = barra && barra.querySelector('[data-q4-barra-pack]');

    // 0. Fin del lanzamiento: al pasar la fecha REAL, la ficha enseña el precio normal aunque la página venga de caché.
    //    Lo mismo con el Black Friday (bf-ini/bf-fin): fuera de sus fechas reales la ficha vuelve al precio normal.
    const fin = Number(sec.dataset.fin || 0) * 1000;
    const bfIni = Number(sec.dataset.bfIni || 0) * 1000, bfFin = Number(sec.dataset.bfFin || 0) * 1000;
    const enBf = () => bfIni && Date.now() >= bfIni && Date.now() < bfFin;
    const enLanzamiento = () => !enBf() && fin > Date.now();
    const pasarANormal = () => {
      radios.forEach((r) => {
        const t = r.closest('.q4-pack'); if (!t) return;
        const p = t.querySelector('[data-q4-precio]'); if (p) p.textContent = r.dataset.normalTxt;
        const s = t.querySelector('[data-q4-tachado]'); if (s) s.remove();
      });
      sec.querySelectorAll('[data-q4-solo-lanzamiento], [data-q4-solo-bf]').forEach((x) => x.remove());
    };
    const conOferta = () => enBf() || enLanzamiento();
    if ((fin || bfFin) && !conOferta()) pasarANormal();
    [fin, bfFin].forEach((h) => { if (h && h > Date.now() && h - Date.now() < 2147483647) setTimeout(() => { if (!conOferta()) { pasarANormal(); marcar(); } }, h - Date.now() + 1000); });

    // 1. Pack elegido: tarjeta marcada, importe del botón y de la barra fija.
    const actual = (r) => (enBf() && Number(r.dataset.bf) ? r.dataset.bfTxt : enLanzamiento() ? r.dataset.lanzTxt : r.dataset.normalTxt);
    const marcar = () => {
      radios.forEach((r) => { const t = r.closest('.q4-pack'); if (t) t.setAttribute('data-activo', r.checked ? 'true' : 'false'); });
      const sel = form.querySelector('input[data-unidades]:checked');
      if (!sel) return;
      if (total) total.textContent = actual(sel);
      if (barraTotal) barraTotal.textContent = actual(sel);
      if (barraPack) barraPack.textContent = sel.dataset.nombre;
    };
    radios.forEach((r) => r.addEventListener('change', marcar));
    marcar();
    {
      const r1 = form.querySelector('input[data-unidades="1"]') || form.querySelector('input[data-unidades]:checked');
      const idv = form.querySelector('[name="id"]');
      const cent = r1 ? Number(enBf() && Number(r1.dataset.bf) ? r1.dataset.bf : enLanzamiento() ? r1.dataset.lanz : r1.dataset.normal) : 0;
      if (cent && idv) publicar('q4_view_item', { currency: moneda, value: cent / 100, item_id: String(idv.value), quantity: 1 });
    }

    // 2. Compra directa: vacía el carrito (sin carritos mixtos, manual 1.14), añade N unidades en UNA línea y va al pago.
    form.addEventListener('submit', async (ev) => {
      if (!window.fetch) return;
      ev.preventDefault();
      const sel = form.querySelector('input[data-unidades]:checked');
      const id = Number(porVariante && sel ? sel.value : form.querySelector('[name="id"]').value);
      const cantidad = porVariante ? 1 : (sel ? Number(sel.value) : 1);
      {
        const n = sel ? Number(sel.dataset.unidades) : cantidad;
        const cent = sel ? Number(enBf() && Number(sel.dataset.bf) ? sel.dataset.bf : enLanzamiento() ? sel.dataset.lanz : sel.dataset.normal) : 0;
        if (cent) publicar('q4_add_to_cart', { currency: moneda, value: cent / 100, item_id: String(id), quantity: n || 1 });
      }
      if (window.clarity) window.clarity('event', 'add_to_cart');
      if (boton) boton.setAttribute('aria-busy', 'true');
      try {
        const carrito = await fetch(raiz + 'cart.js', { headers: json, credentials: 'same-origin' }).then((r) => r.json());
        if (carrito.item_count > 0) await fetch(raiz + 'cart/clear.js', { method: 'POST', headers: json, credentials: 'same-origin' });
        const r = await fetch(raiz + 'cart/add.js', { method: 'POST', headers: json, credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id, quantity: cantidad }] }) });
        if (!r.ok) throw new Error('cart/add ' + r.status);
        if (sel) {
          const esperado = Number(enBf() && Number(sel.dataset.bf) ? sel.dataset.bf : enLanzamiento() ? sel.dataset.lanz : sel.dataset.normal);
          const c = await fetch(raiz + 'cart.js', { headers: json, credentials: 'same-origin' }).then((x) => x.json());
          if (esperado && c.total_price !== esperado) console.warn('[q4] el total del carrito no cuadra con el pack', c.total_price, esperado);
        }
        // 24/10 (auditoría): el web pixel de Shopify (Meta, GA) publica product_added_to_cart en segundo plano tras /cart/add;
        // si se navega al instante, el evento AddToCart se pierde. Se espera ~800 ms antes de ir al pago.
        await new Promise((ok) => setTimeout(ok, 800));
        window.location.href = raiz + 'checkout';
      } catch (e) {
        if (boton) boton.removeAttribute('aria-busy');
        HTMLFormElement.prototype.submit.call(form);
      }
    });

    // 3. Barra fija del móvil: está desde el primer segundo (29/10: Clarity, la mitad se va sin bajar un 10 %; antes salía al
    //    bajar 120 px) y se esconde mientras el botón principal está en pantalla.
    if (barra && boton && 'IntersectionObserver' in window) {
      let botonVisible = false;
      const pintar = () => barra.setAttribute('data-visible', !botonVisible ? 'true' : 'false');
      new IntersectionObserver(([e]) => { botonVisible = e.isIntersecting; pintar(); }).observe(boton);
      window.addEventListener('scroll', pintar, { passive: true });
      const b = barra.querySelector('button');
      if (b) b.addEventListener('click', () => { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
    }

    // 3 bis. Contador hasta la fecha REAL de fin (lanzamiento o Black Friday): igual para todos, sin reinicio; al llegar
    //        a cero desaparece y la ficha pasa al precio que toque (la misma hora que caduca el descuento en Shopify).
    const cont = sec.querySelector('[data-q4-contador]');
    if (cont) {
      const lanzFin = Number(cont.dataset.lanzFin || 0) * 1000;
      const objetivo = () => (enBf() ? bfFin : (lanzFin > Date.now() ? lanzFin : 0));
      const txt = cont.querySelector('[data-q4-contador-txt]');
      const pon = (k, n) => { const x = cont.querySelector('[data-' + k + ']'); if (x) x.textContent = String(n).padStart(2, '0'); };
      const paso = () => {
        const fin2 = objetivo();
        if (!fin2 || fin2 <= Date.now()) { cont.remove(); clearInterval(t); return; }
        if (txt) txt.textContent = enBf() ? cont.dataset.txtBf : cont.dataset.txtLanz;
        let r = Math.floor((fin2 - Date.now()) / 1000);
        pon('d', Math.floor(r / 86400)); r %= 86400; pon('h', Math.floor(r / 3600)); r %= 3600; pon('m', Math.floor(r / 60)); pon('s', r % 60);
        cont.hidden = false;
      };
      const t = setInterval(paso, 1000); paso();
    }

    // 3 ter. Ventana «Who are you shopping for?» (29/10): a los N s, una vez por sesión y nunca si ya se ha pulsado comprar.
    //        Elegir enseña la frase de esa persona, la fecha y «Ship now», que envía el mismo formulario (al pago).
    const ven = sec.querySelector('[data-q4-ventana]');
    if (ven) {
      const visto = () => { try { return sessionStorage.getItem('q4_ventana') === '1'; } catch (e) { return false; } };
      const marcarVisto = () => { try { sessionStorage.setItem('q4_ventana', '1'); } catch (e) {} };
      const cerrar = () => { ven.hidden = true; document.documentElement.classList.remove('q4-sin-scroll'); marcarVisto(); };
      const abrir = () => {
        if (visto() || (boton && boton.getAttribute('aria-busy') === 'true') || document.hidden) return;
        const vt = ven.querySelector('[data-q4-ventana-total]'); if (vt && total) vt.textContent = total.textContent;
        ven.hidden = false; document.documentElement.classList.add('q4-sin-scroll'); marcarVisto();
        const b = ven.querySelector('[data-q4-op]'); if (b) b.focus({ preventScroll: true });
        if (window.clarity) window.clarity('event', 'ventana_abierta');
      };
      ven.querySelectorAll('[data-q4-ventana-x]').forEach((x) => x.addEventListener('click', cerrar));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !ven.hidden) cerrar(); });
      ven.querySelectorAll('[data-q4-op]').forEach((b) => b.addEventListener('click', () => {
        const f = ven.querySelector('[data-q4-ventana-frase]'); if (f) f.textContent = b.dataset.frase || '';
        ven.querySelector('[data-q4-paso="1"]').hidden = true; ven.querySelector('[data-q4-paso="2"]').hidden = false;
        if (window.clarity) window.clarity('event', 'ventana_' + (b.dataset.q4Op || '').toLowerCase());
      }));
      const vc = ven.querySelector('[data-q4-ventana-compra]');
      if (vc) vc.addEventListener('click', () => { vc.setAttribute('aria-busy', 'true'); if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
      if (!visto()) setTimeout(abrir, (Number(ven.dataset.seg) || 20) * 1000);
    }

    // 4. Fecha de entrega: la pinta el bloque común de abajo (ficha y carrito).
  });

  // 4. Fecha de entrega (método de Noasse, nxEntrega de NOASSE/06_tienda, adaptado a EE. UU.): días laborables reales
  //    desde HOY en hora del Este, lunes a viernes y sin festivos federales (con su día observado si caen en fin de
  //    semana). data-min / data-max = la misma horquilla que el pago y la política; data-pais="US" pinta «Mon, Nov 3».
  //    Sin data-pais (p01), el formato anterior («Nov 3») y solo fines de semana.
  const q4Entrega = (() => {
    const cache = {};
    const clave = (d) => d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
    const enesimo = (y, m, wd, n) => { const d = new Date(y, m, 1, 12); let c = 0; while (true) { if (d.getDay() === wd && ++c === n) return d; d.setDate(d.getDate() + 1); } };
    const ultimo = (y, m, wd) => { const d = new Date(y, m + 1, 0, 12); while (d.getDay() !== wd) d.setDate(d.getDate() - 1); return d; };
    const observado = (d) => { const x = new Date(d.getTime()); if (x.getDay() === 6) x.setDate(x.getDate() - 1); else if (x.getDay() === 0) x.setDate(x.getDate() + 1); return x; };
    const federales = (y) => {
      if (cache[y]) return cache[y];
      const s = {};
      [[0, 1], [5, 19], [6, 4], [10, 11], [11, 25]].forEach(([m, d]) => { s[clave(observado(new Date(y, m, d, 12)))] = 1; });   // Año Nuevo, Juneteenth, 4 de julio, Veteranos, Navidad
      [enesimo(y, 0, 1, 3), enesimo(y, 1, 1, 3), ultimo(y, 4, 1), enesimo(y, 8, 1, 1), enesimo(y, 9, 1, 2), enesimo(y, 10, 4, 4)]
        .forEach((d) => { s[clave(d)] = 1; });                                                       // MLK, Presidentes, Memorial, Labor, Colón, Acción de Gracias
      s[clave(observado(new Date(y + 1, 0, 1, 12)))] = 1;                                            // el Año Nuevo del año siguiente puede observarse el 31/12
      return (cache[y] = s);
    };
    const hoyET = (zona) => {
      const p = new Intl.DateTimeFormat('en-US', { timeZone: zona || 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
      const v = (t) => Number(p.find((x) => x.type === t).value);
      return new Date(v('year'), v('month') - 1, v('day'), 12);
    };
    // 24/10 (abrir AU y CA, en borrador hasta el OK del fundador): festivos nacionales de reparto de Canadá (Canada Post) y
    // de Australia, con su día librado si caen en fin de semana (el siguiente laborable libre: 25-26/12 de 2026 → lun 28).
    const pascua = (y) => { const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7,
      m = Math.floor((a + 11 * h + 22 * l) / 451), mes = Math.floor((h + l - 7 * m + 114) / 31), dia = ((h + l - 7 * m + 114) % 31) + 1; return new Date(y, mes - 1, dia, 12); };
    const masDias = (d, n) => { const x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; };
    const otros = {};
    const nacionales = (pais, y) => {
      const k = pais + y; if (otros[k]) return otros[k];
      const s = {}, pon = (d) => { s[clave(d)] = 1; };
      const librado = (d) => { let x = new Date(d.getTime()); while (x.getDay() === 0 || x.getDay() === 6 || s[clave(x)]) x = masDias(x, 1); pon(x); };
      const p = pascua(y);
      if (pais === 'CA') {
        [[0, 1], [6, 1], [8, 30], [10, 11], [11, 25], [11, 26]].forEach(([m, d]) => { const f = new Date(y, m, d, 12); pon(f); if (f.getDay() === 0 || f.getDay() === 6) librado(f); });
        pon(masDias(p, -2));                                                                      // Viernes Santo
        const vic = new Date(y, 4, 24, 12); while (vic.getDay() !== 1) vic.setDate(vic.getDate() - 1); pon(vic);   // Victoria Day
        [enesimo(y, 8, 1, 1), enesimo(y, 9, 1, 2)].forEach(pon);                                  // Labour Day, Thanksgiving
      } else if (pais === 'AU') {
        [[0, 1], [0, 26], [11, 25], [11, 26]].forEach(([m, d]) => { const f = new Date(y, m, d, 12); pon(f); if (f.getDay() === 0 || f.getDay() === 6) librado(f); });
        pon(new Date(y, 3, 25, 12));                                                              // Anzac Day
        [masDias(p, -2), masDias(p, 1), enesimo(y, 5, 1, 2)].forEach(pon);                        // Viernes Santo, lunes de Pascua, King's Birthday
      }
      return (otros[k] = s);
    };
    const ZONAS = { US: 'America/New_York', CA: 'America/Toronto', AU: 'Australia/Sydney' };
    const sumar = (n, us) => {
      const pais = us === true ? 'US' : (us || '');
      const x = pais ? hoyET(ZONAS[pais]) : new Date(); let c = 0;
      const libre = (d) => pais === 'US' ? federales(d.getFullYear())[clave(d)] : pais ? nacionales(pais, d.getFullYear())[clave(d)] || nacionales(pais, d.getFullYear() + 1)[clave(d)] : false;
      while (c < n) { x.setDate(x.getDate() + 1); const w = x.getDay(); if (w !== 0 && w !== 6 && !libre(x)) c++; }
      return x;
    };
    const fmt = (d, us) => us ? d.toLocaleDateString(us === 'AU' ? 'en-AU' : 'en-US', { weekday: 'short', month: 'short', day: 'numeric' }) : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    return { sumar, fmt, federales, nacionales };
  })();
  document.querySelectorAll('[data-q4-llega]').forEach((llega) => {
    // El país de la fecha: el de la plantilla (US) salvo que el visitante esté en Canadá o Australia (mercados CA/AU);
    // en EE. UU. todo sigue igual que antes.
    const visita = window.Shopify && Shopify.country;
    const us = llega.dataset.pais ? (['CA', 'AU'].includes(visita) ? visita : (llega.dataset.pais === 'US' ? 'US' : llega.dataset.pais)) : false;
    const t = llega.querySelector('[data-q4-llega-texto]');
    const min = Number(llega.dataset.min), max = Number(llega.dataset.max);
    if (!t || !(min > 0) || !(max >= min)) return;
    t.textContent = t.textContent.replace('{min}', q4Entrega.fmt(q4Entrega.sumar(min, us), us)).replace('{max}', q4Entrega.fmt(q4Entrega.sumar(max, us), us));
    llega.hidden = false;
  });

  // 4 ter. Contador de la barra de anuncio: «Launch price ends in 7 days 03:12:45» hasta la fecha REAL; en Black Friday
  //        cambia de texto y de fecha; sin oferta, desaparece. Igual para todos, sin reinicio.
  document.querySelectorAll('[data-q4-contador-barra]').forEach((c) => {
    const lf = Number(c.dataset.lanzFin || 0) * 1000, bi = Number(c.dataset.bfIni || 0) * 1000, bf = Number(c.dataset.bfFin || 0) * 1000;
    const txt = c.querySelector('[data-q4-cb-txt]'), reloj = c.querySelector('[data-q4-cb-reloj]');
    const dos = (n) => String(n).padStart(2, '0');
    let t = 0;
    const paso = () => {
      const ahora = Date.now();
      const enBf = bi && ahora >= bi && ahora < bf;
      const fin = enBf ? bf : (lf > ahora ? lf : 0);
      if (!fin) { c.remove(); clearInterval(t); return; }
      if (txt) txt.textContent = enBf ? c.dataset.txtBf : c.dataset.txtLanz;
      let r = Math.floor((fin - ahora) / 1000);
      const d = Math.floor(r / 86400); r %= 86400;
      const h = Math.floor(r / 3600); r %= 3600;
      if (reloj) reloj.textContent = (d > 0 ? d + (d === 1 ? ' day ' : ' days ') : '') + dos(h) + ':' + dos(Math.floor(r / 60)) + ':' + dos(r % 60);
    };
    t = setInterval(paso, 1000); paso();
  });

  // 4 quater. Portada: fuera de las fechas reales de oferta, el precio normal y sin tachado (aunque la página venga de caché).
  document.querySelectorAll('[data-q4-portada]').forEach((x) => {
    const fin = Number(x.dataset.fin || 0) * 1000, bi = Number(x.dataset.bfIni || 0) * 1000, bf = Number(x.dataset.bfFin || 0) * 1000;
    const ahora = Date.now();
    if (!((bi && ahora >= bi && ahora < bf) || fin > ahora)) {
      const p = x.querySelector('[data-q4-p-precio]'); if (p) p.textContent = p.dataset.normal;
      const t = x.querySelector('[data-q4-p-tachado]'); if (t) t.remove();
    }
  });

  // 4 bis. Textos con caducidad real (barra de anuncio: «data-q4-hasta» = fin con zona, en segundos): fuera al pasar la hora.
  document.querySelectorAll('[data-q4-hasta]').forEach((x) => {
    const h = Number(x.dataset.q4Hasta || 0) * 1000;
    if (h && Date.now() >= h) x.remove();
  });

  // 5. Galería: puntos que siguen al desplazamiento.
  document.querySelectorAll('[data-q4-galeria]').forEach((g) => {
    const pista = g.querySelector('.q4-galeria__pista');
    const puntos = g.querySelectorAll('.q4-galeria__puntos button');
    const minis = g.querySelectorAll('.q4-galeria__mini');      // miniaturas (escritorio, piel Impact)
    if (!pista || !puntos.length) return;
    [puntos, minis].forEach((lista) => lista.forEach((b, i) => b.addEventListener('click', () => pista.scrollTo({ left: i * pista.clientWidth, behavior: 'smooth' }))));
    pista.addEventListener('scroll', () => {
      const i = Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth));
      [puntos, minis].forEach((lista) => lista.forEach((b, j) => b.setAttribute('aria-current', j === i ? 'true' : 'false')));
    }, { passive: true });
  });

  // 6. Reseñas: filtro «Con foto», «Ver más» de 12 en 12 y foto ampliada al tocarla.
  document.querySelectorAll('[data-q4-resenas]').forEach((rej) => {
    const sec = rej.closest('section') || document;
    const mas = sec.querySelector('[data-q4-ver-mas]');
    if (mas) mas.addEventListener('click', () => {
      const ocultas = rej.querySelectorAll('[data-q4-mas][hidden]');
      ocultas.forEach((x, i) => { if (i < 12) x.hidden = false; });
      if (ocultas.length <= 12) mas.remove();
    });
    sec.querySelectorAll('[data-q4-filtro]').forEach((b) => b.addEventListener('click', () => {
      sec.querySelectorAll('[data-q4-filtro]').forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      const solo = b.dataset.q4Filtro === 'foto';
      rej.querySelectorAll('.q4-resena').forEach((r) => { r.style.display = solo && !r.hasAttribute('data-con-foto') ? 'none' : ''; });
    }));
  });
  document.addEventListener('click', (ev) => {
    const b = ev.target.closest('[data-q4-ampliar]');
    if (!b) return;
    const img = b.querySelector('img'); if (!img) return;
    const capa = document.createElement('div');
    capa.className = 'q4-ampliada'; capa.setAttribute('role', 'dialog'); capa.setAttribute('aria-label', 'Photo');
    const grande = document.createElement('img'); grande.src = img.currentSrc || img.src; grande.alt = img.alt;
    capa.appendChild(grande);
    const cerrar = () => { capa.remove(); document.removeEventListener('keydown', esc); b.focus(); };
    const esc = (e) => { if (e.key === 'Escape') cerrar(); };
    capa.addEventListener('click', cerrar); document.addEventListener('keydown', esc);
    document.body.appendChild(capa);
  });
})();
